import { FormikHelpers } from 'formik';
import isEqual from '@acorn-portal/shared/src/utils/isEqual';

const useNoChangeWarning = <T>() => {
	const hasChanged = (oldValues: T, newValues: T, formikHelpers?: FormikHelpers<T>) => {
		if (isEqual(oldValues, newValues)) {
			if (formikHelpers) {
				formikHelpers.resetForm();
			}
			return false;
		}
		return true;
	};

	return [hasChanged];
};

export default useNoChangeWarning;
